var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteContentLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    fill: "url(#paint0_linear_5501_133205)",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    stroke: "#E7E6E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 17.8333H28.6663",
    stroke: "#584E63",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 21.1667V26.1667",
    stroke: "#584E63",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.667 21.1667V26.1667",
    stroke: "#584E63",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.167 17.8333L17.0003 27.8333C17.0003 28.2753 17.1759 28.6992 17.4885 29.0118C17.801 29.3243 18.225 29.4999 18.667 29.4999H25.3337C25.7757 29.4999 26.1996 29.3243 26.5122 29.0118C26.8247 28.6992 27.0003 28.2753 27.0003 27.8333L27.8337 17.8333",
    stroke: "#584E63",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.8333V15.3333C19.5 15.1123 19.5878 14.9004 19.7441 14.7441C19.9004 14.5878 20.1123 14.5 20.3333 14.5H23.6667C23.8877 14.5 24.0996 14.5878 24.2559 14.7441C24.4122 14.9004 24.5 15.1123 24.5 15.3333V17.8333",
    stroke: "#584E63",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5501_133205",
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67308F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteContentLight);
export default __webpack_public_path__ + "static/media/deleteContentLight.4df45fd7ce0016eb61295254e3609120.svg";
export { ForwardRef as ReactComponent };